import request from '../request'

export default {
  getDemarcaciones: function getDemarcaciones() {
    return request.get('demarcacion')
  }
}
